import { Pipe, PipeTransform } from '@angular/core';

interface MovimentoStock {
  codArmazem: string;
  codArtigo: string;
  codDocumento: string;
  codEmpresa: string;
  codMovimento: string;
  dataCriacao: Date | string;
  dataMovimento: Date | string;
  idArmazem: number;
  idArtigo: number;
  idEmpresa: number;
  idMovimento: number;
  movimento: string;
  nomeArtigo: string;
  preco: number;
  quantidade: number;
  total: number;
  unidadeMedida: string;
  url: string;
  utilizador: any;
  cliente: any;
}
@Pipe({
  name: 'tabStockExistencia',
  pure: true
}) export class TabStockExistenciaPipe implements PipeTransform {
transform(movimentos: any[] = [], propKey?: string) {
  const totalSaidas: number = this.calcTotalMovimentos(movimentos, 'S', propKey);
  const totalEntradas: number = this.calcTotalMovimentos(movimentos, 'E', propKey);
  return totalEntradas - totalSaidas;
}

calcTotalMovimentos(dados: any[]= [], codMov: string, propKey: string) {
      let movimentos: MovimentoStock[] = [];
      let total = 0;
      if (dados && dados.length && dados.length > 0) {
        movimentos = dados.filter(m => m.codMovimento === codMov);
        total = movimentos.reduce((a, obj) => {
          return a + obj[propKey];
        }, 0);
      }
      return total;
    }

}
